export default __webpack_public_path__ + "static/media/wordIcon.681dd700.svg";